var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./Action-Plan.svg": "./src/icons/svg/Action-Plan.svg",
	"./academy.svg": "./src/icons/svg/academy.svg",
	"./acao-atrasada.svg": "./src/icons/svg/acao-atrasada.svg",
	"./analysis.svg": "./src/icons/svg/analysis.svg",
	"./badge.svg": "./src/icons/svg/badge.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./calendar-check.svg": "./src/icons/svg/calendar-check.svg",
	"./calendar-month.svg": "./src/icons/svg/calendar-month.svg",
	"./caret-right-bold.svg": "./src/icons/svg/caret-right-bold.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./check-list.svg": "./src/icons/svg/check-list.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./closed-padlock.svg": "./src/icons/svg/closed-padlock.svg",
	"./company.svg": "./src/icons/svg/company.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./config.svg": "./src/icons/svg/config.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./dollar.svg": "./src/icons/svg/dollar.svg",
	"./double-check.svg": "./src/icons/svg/double-check.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./drop-down.svg": "./src/icons/svg/drop-down.svg",
	"./drop-up.svg": "./src/icons/svg/drop-up.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./excel2.svg": "./src/icons/svg/excel2.svg",
	"./exchange.svg": "./src/icons/svg/exchange.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./file-export.svg": "./src/icons/svg/file-export.svg",
	"./file-medical.svg": "./src/icons/svg/file-medical.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./gerenciar-usuarios.svg": "./src/icons/svg/gerenciar-usuarios.svg",
	"./graph-up.svg": "./src/icons/svg/graph-up.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./health.svg": "./src/icons/svg/health.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./id-card.svg": "./src/icons/svg/id-card.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./locked.svg": "./src/icons/svg/locked.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./open-padlock.svg": "./src/icons/svg/open-padlock.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./pdf2.svg": "./src/icons/svg/pdf2.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./person-add.svg": "./src/icons/svg/person-add.svg",
	"./person-badge.svg": "./src/icons/svg/person-badge.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./registration.svg": "./src/icons/svg/registration.svg",
	"./save.svg": "./src/icons/svg/save.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./select-selector.svg": "./src/icons/svg/select-selector.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./signal.svg": "./src/icons/svg/signal.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./stopwatch.svg": "./src/icons/svg/stopwatch.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./three-vertical-dots.svg": "./src/icons/svg/three-vertical-dots.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./unlike.svg": "./src/icons/svg/unlike.svg",
	"./unlocked.svg": "./src/icons/svg/unlocked.svg",
	"./user-cog.svg": "./src/icons/svg/user-cog.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";